export const API_MESSAGES_LIST_REQUEST = 'API_MESSAGES_LIST_REQUEST';
export const API_MESSAGES_LIST_SUCCESS = 'API_MESSAGES_LIST_SUCCESS';
export const API_MESSAGES_LIST_FAILURE = 'API_MESSAGES_LIST_FAILURE';

export const API_MESSAGES_SENT_REQUEST = 'API_MESSAGES_SENT_REQUEST';
export const API_MESSAGES_SENT_SUCCESS = 'API_MESSAGES_SENT_SUCCESS';
export const API_MESSAGES_SENT_FAILURE = 'API_MESSAGES_SENT_FAILURE';

export const SHOW_MESSAGE_CENTER = 'SHOW_MESSAGE_CENTER';

export const messagesSentRequest = () => ({
  type: API_MESSAGES_SENT_REQUEST,
});

export const messagesSentSuccess = payload => ({
  type: API_MESSAGES_SENT_SUCCESS,
  payload,
});
export const messagesSentFailure = payload => ({
  type: API_MESSAGES_SENT_FAILURE,
  payload,
});

export const messagesListRequest = () => ({
  type: API_MESSAGES_LIST_REQUEST,
});

export const messagesListSuccess = payload => ({
  type: API_MESSAGES_LIST_SUCCESS,
  payload,
});
export const messagesListFailure = payload => ({
  type: API_MESSAGES_LIST_FAILURE,
  payload,
});

export const showMessageCenter = payload => ({
  type: SHOW_MESSAGE_CENTER,
  payload,
});



const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  list: null,
  sentlist:null,
  showMessageCenterNow:false
};

export function messagesListReducer(state = initialState, action) {
  
  switch (action.type) {
    case API_MESSAGES_SENT_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_MESSAGES_SENT_SUCCESS:
      
      return {
        ...state,
        isFetched: true,
        fetching: false,
        sentlist: action.payload.data,
      };
    case API_MESSAGES_LIST_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_MESSAGES_LIST_SUCCESS:
      
      return {
        ...state,
        isFetched: true,
        fetching: false,
        list: action.payload.data,
      };
      case SHOW_MESSAGE_CENTER:
       
      return {
        ...state,
        showMessageCenterNow: action.payload,
      };
    case API_MESSAGES_LIST_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
      case API_MESSAGES_SENT_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}
